jQuery(document).ready(function($){
  var listWidth = $('.scrolling-bar .scrolling__inner').width();
  var index = 1;
  var counter = 15;
  intervalMouseout = setInterval(myTimer, counter);
  function myTimer() {
      if(index <= listWidth){
          $('.scrolling-bar .scrolling__inner').css('transform','translateX('+index*-1+'px)');
          index++;
      }else{
          index = 1;
      }
  }
})